import ArchiveSeasonStandingsDb from "./ArchiveSeasonStandingsDb.jsx";

export default function ArchiveSeasonStandingsAmDb() {
    return (
        <ArchiveSeasonStandingsDb
            scopeType="DRIVER"
            classKey="AM"
            title="Archiv Standings AM"
            pillLabel="AM"
        />
    );
}
